import React, { FC } from 'react';

import { IRole } from '../../../../../models/types';

import Table from '../../../../../components_/Table';
import TableColLink from '../../../../../components_/Table/TableColLink';
import TableColText from '../../../../../components_/Table/TableColText';
import TableActionGroup from '../../../../../components_/Table/TableActionGroup';
import { CopyOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';

export interface IProps {
  list: IRole[];
  onClickEdit: any;
  onClickDelete: any;
  onClickCopy: any;
}

const List: FC<IProps> = ({ list, onClickEdit, onClickDelete, onClickCopy }) => {
  const rows = list.map(item => ({
    items: {
      friendlyName: (
        <TableColText onClick={onClickEdit(item)}>
          <TableColLink>{item.friendlyName}</TableColLink>
        </TableColText>
      ),
      actions: (
        <TableActionGroup>
          <Button type={'text'} onClick={onClickEdit(item)} icon={<EditOutlined />} />
          <Button type={'text'} onClick={onClickCopy(item)} icon={<CopyOutlined />} />
          <Button type={'text'} danger onClick={onClickDelete(item)} icon={<DeleteOutlined />} />
        </TableActionGroup>
      )
    }
  }));

  const cols = [
    {
      title: 'Название',
      field: 'friendlyName'
    },
    {
      title: '',
      field: 'actions'
    }
  ];

  return <Table cols={cols} rows={rows} />;
};

export default List;
